var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",style:({
    'opacity': _vm.visible ? 1 : 0,
    'width' : _vm.visible ? '100%' : '0%',
    'height' : _vm.visible ? '100%' : '0%'
  })},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-three-bounce"},[_c('div',{staticClass:"sk-child sk-bounce1"}),_c('div',{staticClass:"sk-child sk-bounce2"}),_c('div',{staticClass:"sk-child sk-bounce3"})])}]

export { render, staticRenderFns }